/* ZILURA redesign: hero slider (<zl-hero>) and product tabs (<zl-tabs>). */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!customElements.get('zl-hero')) {
    customElements.define(
      'zl-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.prototype.slice.call(this.querySelectorAll('.zr-hero__slide'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('.zr-hero__dot'));
          this.index = 0;
          if (this.slides.length < 2) return;
          var self = this;
          this.addEventListener('click', function (e) {
            var dot = e.target.closest('[data-go]');
            var step = e.target.closest('[data-step]');
            if (dot) self.go(parseInt(dot.dataset.go, 10), true);
            if (step) self.go(self.index + parseInt(step.dataset.step, 10), true);
          });
          // swipe on touch screens
          var x0 = null;
          this.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
          this.addEventListener('touchend', function (e) {
            if (x0 === null) return;
            var dx = e.changedTouches[0].clientX - x0;
            if (Math.abs(dx) > 50) self.go(self.index + (dx < 0 ? 1 : -1), true);
            x0 = null;
          });
          this.delay = parseInt(this.dataset.autoplay, 10) || 0;
          if (this.delay && !reduceMotion && !(window.Shopify && Shopify.designMode)) {
            this.addEventListener('mouseenter', function () { self.paused = true; });
            this.addEventListener('mouseleave', function () { self.paused = false; });
            this.addEventListener('focusin', function () { self.paused = true; });
            this.addEventListener('focusout', function () { self.paused = false; });
            this.timer = setInterval(function () {
              if (!self.paused && !document.hidden) self.go(self.index + 1, false);
            }, this.delay * 1000);
          }
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        go(i, user) {
          var n = this.slides.length;
          i = ((i % n) + n) % n;
          if (i === this.index) return;
          var self = this;
          this.slides.forEach(function (s, k) {
            var on = k === i;
            s.classList.toggle('is-active', on);
            s.toggleAttribute('inert', !on);
            s.setAttribute('aria-hidden', on ? 'false' : 'true');
            s.querySelectorAll('.zr-seen, .zr-hero__pick').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
          });
          this.dots.forEach(function (d, k) {
            d.classList.toggle('is-active', k === i);
            d.setAttribute('aria-pressed', k === i ? 'true' : 'false');
          });
          this.index = i;
          if (user && this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      }
    );
  }

  // Desktop menu: open dropdowns on hover (mouse devices only); click still works for keyboard/touch.
  // Shares the data-zl-hover flag with the older footer snippet so a menu is never bound twice.
  function bindHoverMenus() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (d.dataset.zlHover) return;
      d.dataset.zlHover = '1';
      var summary = d.querySelector('summary');
      var timer;
      function setOpen(open) {
        if (open) d.setAttribute('open', '');
        else d.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      d.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) {
          if (o !== d) {
            o.removeAttribute('open');
            var s = o.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });
        setOpen(true);
      });
      d.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { setOpen(false); }, 250);
      });
      // a click while hovering keeps it open instead of toggling it shut
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (d.hasAttribute('open') && d.matches(':hover')) e.preventDefault();
        });
      }
    });
  }
  if (document.readyState !== 'loading') bindHoverMenus();
  else document.addEventListener('DOMContentLoaded', bindHoverMenus);

  // "Copy" on offer codes
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-zr-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-zr-copy');
    function done() {
      btn.textContent = 'Copied';
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.textContent = 'Copy';
        btn.classList.remove('is-copied');
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      ta.remove();
      done();
    }
  });

  if (!customElements.get('zl-tabs')) {
    customElements.define(
      'zl-tabs',
      class extends HTMLElement {
        connectedCallback() {
          var tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
          var self = this;
          function select(tab) {
            tabs.forEach(function (t) {
              var on = t === tab;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on ? 'true' : 'false');
              t.tabIndex = on ? 0 : -1;
              var panel = self.querySelector('#' + t.getAttribute('aria-controls'));
              if (panel) panel.hidden = !on;
            });
          }
          tabs.forEach(function (t, i) {
            t.addEventListener('click', function () { select(t); });
            t.addEventListener('keydown', function (e) {
              var j = null;
              if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
              if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
              if (j !== null) {
                e.preventDefault();
                tabs[j].focus();
                select(tabs[j]);
              }
            });
          });
        }
      }
    );
  }
})();

/* Product cards on phones/tablets: keep the photo dots in step with the swipeable strip (zilura-card-slides) */
document.addEventListener(
  'scroll',
  function (event) {
    var track = event.target;
    if (!track.classList || !track.classList.contains('zl-cslides__track')) return;
    var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    var dots = track.parentElement.querySelectorAll('.zl-cslides__dots span');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
  },
  true
);

/* Cart coupons (snippets/zilura-coupons): Apply / Remove a discount code on the cart itself, so it carries to checkout */
(function () {
  var updateUrl = (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';

  function showMessage(box, text) {
    var msg = box && box.querySelector('.zl-coupons__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
  }

  function rerenderDrawer(sections) {
    var parse = function (html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    };
    var drawer = document.querySelector('cart-drawer');
    var current = document.getElementById('CartDrawer');
    var fresh = sections && sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
    if (drawer && current && fresh) {
      current.innerHTML = fresh.innerHTML;
      var overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    var bubble = document.getElementById('cart-icon-bubble');
    var freshBubble = sections && sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
  }

  function setCode(code, button) {
    var inDrawer = !!button.closest('cart-drawer');
    var box = button.closest('[data-zl-coupons]');
    var label = button.textContent;
    button.disabled = true;
    button.textContent = code ? 'Applying…' : 'Removing…';
    showMessage(box, '');

    var payload = { discount: code };
    if (inDrawer) payload.sections = ['cart-drawer', 'cart-icon-bubble'];

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) {
          return String(d.code).toUpperCase() === String(code).toUpperCase();
        })[0];
        if (code && hit && !hit.applicable) {
          button.disabled = false;
          button.textContent = label;
          showMessage(box, code + " isn't valid for this cart yet.");
          return;
        }
        if (inDrawer && cart.sections) {
          rerenderDrawer(cart.sections); // the drawer's coupon section comes back collapsed
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
        showMessage(box, 'Could not update the coupon. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-zl-coupon-apply]');
    if (apply) {
      event.preventDefault();
      setCode(apply.getAttribute('data-zl-coupon-apply'), apply);
      return;
    }
    var remove = event.target.closest('[data-zl-coupon-remove]');
    if (remove) {
      event.preventDefault();
      setCode('', remove);
    }
  });
})();

/* Cart drawer: an open coupon section closes when the customer taps anywhere outside it */
document.addEventListener('click', function (event) {
  var open = document.querySelectorAll('.zl-coupons--drawer[open]');
  for (var i = 0; i < open.length; i++) {
    if (!open[i].contains(event.target)) open[i].open = false;
  }
});

/* "Pick 1 FREE" picker (snippets/zilura-b1g2): one-tap add of a ₹199 pair. On a product page the pair being viewed
   is added too (once), so customers can build their 2 pairs from there. Refreshes the cart drawer, or reloads the cart page. */
(function () {
  var root = (window.routes && window.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  function note(box, text) {
    var msg = box && box.querySelector('.zl-pick__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
  }

  function add(button) {
    var box = button.closest('[data-zl-pick]');
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.querySelector('cart-items:not(cart-drawer-items)') && !button.closest('cart-drawer');
    var withId = box && box.getAttribute('data-zl-pick-with');
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    note(box, '');

    var items = [{ id: Number(button.getAttribute('data-zl-pick-add')), quantity: 1 }];
    var ready = withId
      ? fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var has = (cart.items || []).some(function (i) {
              return String(i.variant_id) === String(withId);
            });
            if (!has) items.unshift({ id: Number(withId), quantity: 1 });
          })
      : Promise.resolve();

    ready
      .then(function () {
        var payload = { items: items };
        if (drawer && !onCartPage) payload.sections = ['cart-drawer', 'cart-icon-bubble'];
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
      })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'error');
          return data;
        });
      })
      .then(function (data) {
        if (drawer && !onCartPage && data.sections && drawer.renderContents) {
          drawer.renderContents(data); // re-renders the drawer (with the updated picker) and opens it
        } else {
          window.location.reload();
        }
      })
      .catch(function (e) {
        button.disabled = false;
        button.textContent = label;
        note(box, e && e.message && e.message !== 'error' ? e.message : 'Could not add this. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var size = event.target.closest('[data-zl-pick-size]');
    if (size) {
      // bangle picker (snippets/zilura-bangle-offer): the size button sets which variant + Add adds
      var item = size.closest('.zl-pick__item');
      item.querySelectorAll('[data-zl-pick-size]').forEach(function (b) {
        b.classList.toggle('is-on', b === size);
        b.setAttribute('aria-pressed', b === size ? 'true' : 'false');
      });
      var addBtn = item.querySelector('[data-zl-pick-add]');
      if (addBtn) addBtn.setAttribute('data-zl-pick-add', size.getAttribute('data-zl-pick-size'));
      return;
    }
    var button = event.target.closest('[data-zl-pick-add]');
    if (!button) return;
    event.preventDefault();
    add(button);
  });
})();

/* ZILURA "Buy 1, Pick 1 FREE" countdown: fills every [data-zl-countdown] (popup, product banner, cart hint,
   announcement bar) from window.zlOfferEnds (snippets/zilura-offer-ends.liquid). Styles: default
   "Ends in 2d 23h 59m 12s", "compact" "Ends in 71:59:12", "boxes" days/hrs/min/sec tiles. When the time is up
   it adds html.zl-offer-ended, which hides the offer pieces still on screen (assets/zilura-redesign.css).
   The offer is permanent for now (window.zlOfferEnds is empty), so this does nothing. */
(function () {
  var ends = Date.parse(window.zlOfferEnds || '');
  if (!ends) return;
  var pad = function (n) {
    return (n < 10 ? '0' : '') + n;
  };

  function tick() {
    var left = Math.max(0, ends - Date.now());
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (!left) document.documentElement.classList.add('zl-offer-ended');

    document.querySelectorAll('[data-zl-countdown]').forEach(function (el) {
      var style = el.getAttribute('data-zl-countdown');
      if (style === 'boxes') {
        el.innerHTML = [
          [d, 'days'],
          [h, 'hrs'],
          [m, 'min'],
          [sec, 'sec'],
        ]
          .map(function (p) {
            return '<span class="zl-cd__box"><b>' + pad(p[0]) + '</b><small>' + p[1] + '</small></span>';
          })
          .join('');
        el.setAttribute('aria-label', d + ' days ' + h + ' hours ' + m + ' minutes left');
      } else if (style === 'compact') {
        el.textContent = left ? 'Ends in ' + pad(d * 24 + h) + ':' + pad(m) + ':' + pad(sec) : 'Offer ended';
      } else {
        el.textContent = left ? 'Ends in ' + (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's' : 'Offer ended';
      }
    });
    if (left) setTimeout(tick, 1000 - (Date.now() % 1000));
  }
  tick();
})();

/* Phones, cart page: a sticky "To pay ₹… · Place order" bar while the real checkout button is off-screen.
   Tapping it clicks the real button, so checkout works exactly as before. The amount is read from the
   order summary ("To pay" in snippets/zilura-fare.liquid) each time, so it follows quantity changes. */
(function () {
  var cartUrl = (window.routes && routes.cart_url) || '/cart';
  if (window.location.pathname !== cartUrl) return;

  var phone = window.matchMedia('(max-width: 749px)');
  var bar = document.createElement('div');
  bar.className = 'zl-cartbar';
  bar.hidden = true;
  bar.innerHTML =
    '<div class="zl-cartbar__pay"><span>To pay</span><strong data-zl-cartbar-total></strong></div>' +
    '<button type="button" class="zl-cartbar__btn"><span>Place order</span></button>';
  document.body.appendChild(bar);
  var totalEl = bar.querySelector('[data-zl-cartbar-total]');
  var barBtn = bar.querySelector('.zl-cartbar__btn');

  function realButton() {
    return document.querySelector('#main-cart-footer .cart__checkout-button, .cart__footer .cart__checkout-button');
  }

  function update() {
    var btn = realButton();
    var total = document.querySelector('.cart__footer .zl-fare__row--total span:last-child');
    var show = false;
    if (phone.matches && btn && !btn.disabled) {
      var r = btn.getBoundingClientRect();
      show = r.top > window.innerHeight || r.bottom < 0;
    }
    if (total) totalEl.textContent = total.textContent.trim();
    if (btn && !barBtn.querySelector('.zl-upi')) {
      var upi = btn.querySelector('.zl-upi');
      if (upi) barBtn.appendChild(upi.cloneNode(true));
    }
    bar.hidden = !show;
    document.body.classList.toggle('zl-has-cartbar', show);
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      update();
    });
  }

  barBtn.addEventListener('click', function () {
    var btn = realButton();
    if (btn) btn.click();
  });
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  // the cart section is re-rendered after quantity changes
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  update();
})();

/* "Pick 1 FREE" rows: Liquid can only list a collection's first 50 products, so append the remaining
   in-stock ₹199 pairs from /collections/buy-1-get-1-free/products.json, copying the first rendered card.
   Runs for every row on the page, including rows re-rendered inside the cart drawer. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var poolRequest = null;
  function pool() {
    if (!poolRequest) {
      poolRequest = fetch(root + 'collections/buy-1-get-1-free/products.json?limit=250', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          return d.products || [];
        })
        .catch(function () {
          return [];
        });
    }
    return poolRequest;
  }

  function sizedImage(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function fill(box) {
    if (box.hasAttribute('data-zl-pick-filled')) return;
    box.setAttribute('data-zl-pick-filled', '');
    var list = box.querySelector('.zl-pick__list');
    var template = list && list.querySelector('.zl-pick__item');
    if (!template) return;
    var skip = ',' + (box.getAttribute('data-zl-pick-skip') || '') + ',';
    var shown = {};
    list.querySelectorAll('[data-zl-pick-add]').forEach(function (b) {
      shown[b.getAttribute('data-zl-pick-add')] = true;
    });

    pool().then(function (products) {
      products.forEach(function (p) {
        var v = (p.variants || []).filter(function (x) {
          return x.available;
        })[0];
        if (!v || shown[String(v.id)] || skip.indexOf(',' + p.id + ',') !== -1) return;
        shown[String(v.id)] = true;
        var li = template.cloneNode(true);
        var url = root + 'products/' + p.handle;
        li.querySelectorAll('a').forEach(function (a) {
          a.href = url;
        });
        var name = li.querySelector('.zl-pick__name');
        if (name) name.textContent = p.title;
        var img = li.querySelector('img');
        var image = (p.images && p.images[0] && p.images[0].src) || '';
        if (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.loading = 'lazy';
          img.src = sizedImage(image);
        }
        var btn = li.querySelector('[data-zl-pick-add]');
        if (btn) {
          btn.setAttribute('data-zl-pick-add', String(v.id));
          btn.disabled = false;
          btn.textContent = '+ Add';
        }
        list.appendChild(li);
      });
      var count = box.querySelector('[data-zl-pick-count]');
      var total = list.querySelectorAll('.zl-pick__item').length;
      if (count) count.textContent = total + ' pairs · swipe →';
    });
  }

  function scan() {
    document.querySelectorAll('[data-zl-pick]:not([data-zl-pick-filled])').forEach(fill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(function () {
    if (document.querySelector('[data-zl-pick]:not([data-zl-pick-filled])')) scan();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Product page: the Razorpay Magic Checkout "Buy Now" button (snippets/razorpay-magic-checkout.liquid) in
   ZILURA wine with a pill shape, set through the button's own bg-color / border-radius attributes because
   it draws inside a closed shadow root. On phones the buy block (quantity, Add to cart, Buy Now) docks to
   the bottom of the screen whenever its own spot is off-screen. It is the same block moved with CSS (a
   placeholder keeps its space), so quantity, variants and both buttons work exactly as before.
   Styles: assets/zilura-redesign.css (.zl-buybar). */
(function () {
  var MAGIC_BG = '#5b1a33';
  function brandMagic() {
    document.querySelectorAll('magic-checkout-btn').forEach(function (b) {
      if (b.getAttribute('bg-color') !== MAGIC_BG) b.setAttribute('bg-color', MAGIC_BG);
      if (b.getAttribute('border-radius') !== '999px') b.setAttribute('border-radius', '999px');
    });
  }
  brandMagic();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.tagName === 'MAGIC-CHECKOUT-BTN' || (n.querySelector && n.querySelector('magic-checkout-btn')))) {
          brandMagic();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  var block = document.querySelector('product-info[id^="MainProduct"] .product-form__buttons');
  if (!block || !('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;
  var phone = window.matchMedia('(max-width: 749px)');
  /* The placeholder always covers the block's own spot, docked or not, so "is the spot on screen" never
     changes just because the block moved (that flip-flop made the bar jump). Undocked it sits on top of the
     block with a negative bottom margin, so it takes no space; docked it holds the space the block left. */
  var ph = document.createElement('div');
  ph.className = 'zl-buybar-ph';
  ph.setAttribute('aria-hidden', 'true');
  block.parentNode.insertBefore(ph, block);
  block.classList.add('zl-buybar');
  var docked = false;
  var spotH = block.offsetHeight;
  var measuredWithMagic = !!block.querySelector('.magic-buy-btn__parent');

  function place() {
    ph.style.height = spotH + 'px';
    ph.style.marginBottom = docked ? '0px' : -spotH + 'px';
  }
  function setDocked(on) {
    on = on && phone.matches;
    if (on === docked) return;
    docked = on;
    place();
    document.body.classList.toggle('zl-buybar-on', on);
    if (on) {
      requestAnimationFrame(function () {
        document.body.style.setProperty('--zl-buybar-h', block.offsetHeight + 'px');
      });
    }
  }
  // the spot's height, measured only while the block is in its own place
  new ResizeObserver(function () {
    if (docked) return;
    spotH = block.offsetHeight;
    measuredWithMagic = !!block.querySelector('.magic-buy-btn__parent');
    place();
  }).observe(block);
  // Razorpay adds its button later; if that happens while docked, grow the held space by the in-page size
  // of its button (its own CSS: 75px tall) plus the 10px gap, so nothing jumps when the block returns
  new MutationObserver(function () {
    if (docked && !measuredWithMagic && block.querySelector('.magic-buy-btn__parent')) {
      measuredWithMagic = true;
      spotH += 85;
      place();
    }
  }).observe(block, { childList: true, subtree: true });
  place();
  new IntersectionObserver(function (entries) {
    setDocked(!entries[0].isIntersecting);
  }).observe(ph);
  phone.addEventListener('change', function () {
    if (!phone.matches) setDocked(false);
  });
})();

/* Product page share button (sections/main-product.liquid, [data-zl-share]): the phone's own share sheet
   (WhatsApp, Instagram...) where the browser has one, otherwise the link is copied and a toast says so. */
(function () {
  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('.zl-share-toast');
    if (!t) {
      t = document.createElement('p');
      t.className = 'zl-share-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.hidden = true;
    }, 2500);
  }
  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      ta.remove();
      ok ? resolve() : reject();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zl-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-zl-share-url') || location.href;
    var title = btn.getAttribute('data-zl-share-title') || document.title;
    var text = title + ' on ZILURA';
    if (navigator.share) {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
      return;
    }
    copy(url).then(
      function () {
        toast('Link copied');
      },
      function () {
        toast('Copy this link: ' + url);
      }
    );
  });
})();
